/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Meta_PageInputs */

const ja_contact_meta_page = /** @type {(inputs: Contact_Meta_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`contact`)
};

const en_contact_meta_page = /** @type {(inputs: Contact_Meta_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`contact`)
};

/**
* | output |
* | --- |
* | "contact" |
*
* @param {Contact_Meta_PageInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const contact_meta_page = /** @type {((inputs?: Contact_Meta_PageInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Meta_PageInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_meta_page(inputs)
	return en_contact_meta_page(inputs)
});